/* eslint-disable no-restricted-properties */

import { createEnv } from "@t3-oss/env-core"
import { z } from "zod"

// must be relative, import alias cannot be read by next.config.ts at the moment - probably because its transpiled to commonjs not esm - cant read "imports" array from package.json
import { zBooleanOnly } from "../validation/primitives"
import { createCIEnvValidationHandler } from "./envValidationHandler"

// No problem to keep server and client validation inside the same file (server variable names get shipped to client) as long as there is no sensitive information inside the env variable names https://env.t3.gg/docs/nextjs

export function baseEnv(NOT_AVAILABLE_ON_CI: string[]) {
  return createEnv({
    emptyStringAsUndefined: true,
    server: {
      // Deployment
      CI: zBooleanOnly.optional(),
      NODE_ENV: z.enum(["development", "production", "test"]).default("development"),
    },
    runtimeEnv: {
      // If new env variables are added and get an ESLINT error for turbo/... add them to the root turbo.json globalEnv array and restart ESLINT service of editor if error stays

      NODE_ENV: process.env.NODE_ENV,

      // Deployment
      CI: process.env.CI,
    },
    // Dont use client variables here since this is a generic env file and client variables almost always need a package specific prefix
    // clientPrefix: "",
    // client: {},

    onValidationError: createCIEnvValidationHandler(NOT_AVAILABLE_ON_CI),
  })
}
